<div class="inner-mat-dialog title-section flex justify-between content-stretch items-stretch flex-col">

  <div mat-dialog-title id="drug-details-header">
    <div class="flex justify-start content-center items-center flex-row">
      <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
        <h3>DRUG IMAGES</h3>
      </div>
    </div>
  </div>

  <div class="row flex flex-col justify-center content-center items-center w-full gap-[1rem]"
    style="margin-bottom: .8rem;">
    <div class="flex flex-col basis-1/5 data-source-container">
      <span class="label">Data Source</span>
      <mat-form-field>
        <mat-select [(ngModel)]="dataSource" ngDefaultControl>
          <mat-option *ngFor="let data of listOfDataSource" [value]="data.value">{{data?.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-col basis-1/5">
      <button mat-button aria-label="Save Drug" style="margin-top: 1.5rem;" (click)="getSliderImage()"
        class="btn-sm btn-primary" type="button">Search</button>
    </div>
  </div>

  <!-- Image Slideshow Section -->
  <div class="images-container">
    <div *ngIf="slides?.length > 0" class="images-slideshow">
      <div class="imagesSlides fade" *ngFor="let slide of slides; let i = index">
        <div *ngIf="currentIndex === i" class="image-wrapper">
          <span class="image-label">{{slide.imageName}}</span>
          <img [src]="slide.serialImage" class="consistent-image" />
          <mat-icon *ngIf="isEdit && dataSource == 3" color="warn" (click)="onDeleteImage(slide.blobName)" style="cursor: pointer; margin-top: 5px;">
            delete
          </mat-icon>
        </div>
      </div>
      <div *ngIf="dataSource == 3 && isEdit" class="div-flex">
        <div *ngIf="isEmptyImage || currentIndex>=slides.length" class="image-wrapper">
          <div class="file-upload">
              <div class="selected-file">
                <img class="img-style" [src]="getBase64ImageSrc(addImage)??defaultImage" alt="drug image">
              </div>
              <div class="remove-button" *ngIf="dataSource == 3 && addImage!= null">
                <button class="remove-button btn btn-active" (click)="selectedFileRemove()">
                  <mat-icon>clear</mat-icon>Remove</button>
              </div>
              <div class="choose_file_syn" *ngIf="addImage == null">
                <label for="choose_file_syn">
                  <input type="file" id="choose_file_syn" accept="image/png, image/gif, image/jpeg"
                    (change)="onFileSelected($event)">
                  <span>SELECT ADD IMAGE</span>
                </label>

              </div>

            </div>
        </div>
        <div *ngIf="dataSource == 3 && addImage!=null">
          <span class="label">Select Image Type</span>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-select [(value)]="selectedImageTypeId" (selectionChange)="prepareFile($event.value)">
              <mat-option *ngFor="let type of imageTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- Previous and Next Buttons -->
      <a *ngIf="currentIndex !== 0" class="slider-btn previous" (click)="slideShow(false)">
        < </a>
          <a *ngIf="currentIndex !== forwardButtonLength" class="slider-btn next" (click)="slideShow(true)"> > </a>
    </div>

    <!-- Placeholder when there are no images -->
    <div *ngIf="slides?.length === 0  && !(isEmptyImage && dataSource == 3 && isEdit)" class="images-placeholder">
      <img src='/assets/img/no-image.png' alt="No Image" class="no-image" />
    </div>

    <div *ngIf="slides?.length === 0 && (isEmptyImage && dataSource == 3 && isEdit)" class="div-flex">
      <div *ngIf="isEmptyImage || currentIndex>=slides.length" class="image-wrapper">
          <div class="file-upload">
              <div class="selected-file">
                <img class="img-style" [src]="getBase64ImageSrc(addImage)??defaultImage" alt="drug image">
              </div>
              <div class="remove-button" *ngIf="dataSource == 3 && addImage!= null">
                <button class="remove-button btn btn-active" (click)="selectedFileRemove()">
                  <mat-icon>clear</mat-icon>Remove</button>
              </div>
              <div class="choose_file_syn" *ngIf="addImage == null">
                <label for="choose_file_syn">
                  <input type="file" id="choose_file_syn" accept="image/png, image/gif, image/jpeg"
                    (change)="onFileSelected($event)">
                  <span>SELECT ADD IMAGE</span>
                </label>

              </div>

            </div>
        </div>
        <div *ngIf="dataSource == 3 && addImage!=null">
          <span class="label">Select Image Type</span>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-select [(value)]="selectedImageTypeId" (selectionChange)="prepareFile($event.value)">
              <mat-option *ngFor="let type of imageTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
    </div>
  </div>

  <mat-dialog-actions class="flex flex-row justify-end content-end items-end w-full xs:flex xs:flex-col">
    <button mat-button class="btn-blue-light btn-md" (click)="dialogRef.close()" id="CancelNewUser" aria-label="Cancel"
      type="button">Cancel</button>
    <button *ngIf="dataSource ==3 && isEdit && addImage !=null " mat-button aria-label="Done" (click)="addNewImage()"
        [disabled]="selectedImageTypeId==null" class="btn-primary btn-md" type="button">Save
    </button>
  </mat-dialog-actions>
</div>
